import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { EnableSignUpSessionRecording } from '~/constants/ff.posthog';
import { useFeatureFlag } from './useFeatureFlag';
import { usePosthog } from './usePosthog';

const REGISTRATION_PATH = '/registration';

export const useSignUpPosthogSessionRecording = () => {
  const location = useLocation();
  const posthog = usePosthog();
  const isRecordingRef = useRef(false);
  const hasStartedSignupRef = useRef(false);
  const isEnabled = useFeatureFlag(EnableSignUpSessionRecording);

  useEffect(() => {
    const isOnRegistration = location.pathname.startsWith(REGISTRATION_PATH);

    // Track if user entered registration flow this session
    if (isEnabled && isOnRegistration) {
      hasStartedSignupRef.current = true;
    }

    // Start recording if enabled and user is on registration or has been through signup this session
    const shouldRecord = isEnabled && hasStartedSignupRef.current;

    if (shouldRecord && !isRecordingRef.current) {
      posthog.startSessionRecording();
      isRecordingRef.current = true;
    }
  }, [location.pathname, posthog, isEnabled]);

  // Stop recording on unmount only (when browser/tab closes)
  useEffect(() => {
    return () => {
      posthog.stopSessionRecording();
    };
  }, [posthog]);
};
